// API action types
export const PROCESSING_STOCK_TRANSFER = '@@toyota/PROCESSING_STOCK_TRANSFER';
export const PROCESSED_STOCK_TRANSFER = '@@toyota/PROCESSED_STOCK_TRANSFER';
export const PROCESSED_STOCK_TRANSFER_FAILED = '@@toyota/PROCESSED_STOCK_TRANSFER_FAILED';
export const CREATING_NEW_TRANSFER = '@@toyota/CREATING_NEW_TRANSFER';
export const CREATED_NEW_TRANSFER = '@@toyota/CREATED_NEW_TRANSFER';
export const CREATED_NEW_TRANSFER_FAILED = '@@toyota/CREATED_NEW_TRANSFER_FAILED';
export const SUBMITTING_TRANSFER = '@@toyota/SUBMITTING_TRANSFER';
export const SUBMITTED_TRANSFER = '@@toyota/SUBMITTED_TRANSFER';
export const SUBMITTED_TRANSFER_FAILED = '@@toyota/SUBMITTED_TRANSFER_FAILED';
export const REJECTING_TRANSFER = '@@toyota/REJECTING_TRANSFER';
export const REJECTED_TRANSFER = '@@toyota/REJECTED_TRANSFER';
export const REJECTED_TRANSFER_FAILED = '@@toyota/REJECTED_TRANSFER_FAILED';
export const ADDING_TRANSFER_ITEM = '@@toyota/ADDING_TRANSFER_ITEM';
export const ADDED_TRANSFER_ITEM = '@@toyota/ADDED_TRANSFER_ITEM';
export const ADDED_TRANSFER_ITEM_FAILED = '@@toyota/ADDED_TRANSFER_ITEM_FAILED';
export const REMOVING_TRANSFER_ITEM = '@@toyota/REMOVING_TRANSFER_ITEM';
export const REMOVED_TRANSFER_ITEM = '@@toyota/REMOVED_TRANSFER_ITEM';
export const REMOVED_TRANSFER_ITEM_FAILED = '@@toyota/REMOVED_TRANSFER_ITEM_FAILED';
